const macDownload: unknown = import.meta.env.VITE_JOT_DESKTOP_MAC_DOWNLOAD_URL;
const windowsDownload: unknown = import.meta.env.VITE_JOT_DESKTOP_WINDOWS_DOWNLOAD_URL;

/** Publish download URLs only after the corresponding installer is ready for customers. */
export const desktopDownloads = {
  mac:
    (typeof macDownload === 'string' ? macDownload : undefined) ||
    (import.meta.env.DEV
      ? `${import.meta.env.BASE_URL}jot-desktop-demo/Jot-Companion-Pilot-Mac-universal.dmg`
      : undefined),
  windows:
    (typeof windowsDownload === 'string' ? windowsDownload : undefined) ||
    (import.meta.env.DEV
      ? `${import.meta.env.BASE_URL}jot-desktop-demo/Jot-Companion-Pilot-Windows-x64-unsigned.exe`
      : undefined),
};
export function desktopPlatform(): 'mac' | 'windows' | null {
  if (
    typeof navigator === 'undefined' ||
    /Android|iPhone|iPad/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
    return null;
  if (/Mac/.test(navigator.platform)) return 'mac';
  return /Win/.test(navigator.platform) ? 'windows' : null;
}
